import { useEffect, useState } from 'react';
import networker from '..';
import { PostResponse } from '../../../types/models/posts';

export function useFetchLastThreePosts() {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const [posts, setPosts]: [PostResponse[], any] = useState([]);

  useEffect(() => {
    setIsLoading(true);
    setHasError(false);

    networker.getLastThreePosts()
      .then((res) => {
        if (!res) return setPosts([]);
        setPosts(res);
        setIsLoading(false);
      })
      .catch(err => {
        setHasError(true);
      });

  }, []);

  return {
    isLoading,
    hasError,
    posts
  };
}
